var fillInPage = (function() {
    var isHoliday = function(date) {
        var holidays = ['01/01', '05/26', '07/04', '09/01', '11/27', '12/25']; // Updated holidays
        var formattedDate = (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getDate().toString().padStart(2, '0');
        return holidays.includes(formattedDate);
    };

    var isWeekend = function(date) {
        var day = date.getDay();
        return day === 0 || day === 6; // Sunday = 0, Saturday = 6
    };

    var getNextValidDate = function(date) {
        while (isWeekend(date) || isHoliday(date)) {
            date.setDate(date.getDate() + 1); // Move to the next valid business day
        }
        return date;
    };

    // Function to calculate the countdown timer to 1:30 PM
    var calculateCountdown = function() {
        var now = new Date();
        var targetTime = new Date();

        // If it's weekend or holiday, skip to the next valid business day for 1:30 PM
        if (isWeekend(now) || isHoliday(now)) {
            targetTime = getNextValidDate(new Date(now)); // Skip weekends and holidays
        }

        targetTime.setHours(13, 30, 0, 0); // Set target time to 1:30 PM on the next valid day

        // If it's already past 1:30 PM on a business day, set the target time to 1:30 PM the next business day
        if (now > targetTime) {
            targetTime.setDate(targetTime.getDate() + 1);
            targetTime = getNextValidDate(targetTime); // Ensure the next valid date is a business day
        }

        var timeDifference = targetTime - now;

        // Convert time difference to hours and minutes
        var hours = Math.floor(timeDifference / (1000 * 60 * 60));
        var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

        return { hours, minutes };
    };

    // Function to display the countdown timer
    var displayCountdown = function() {
        var countdown = calculateCountdown();
        var countdownTimerElement = document.getElementById('countdown-timer');

        // Display the countdown in hours and minutes only
        countdownTimerElement.textContent = countdown.hours + 'h ' + countdown.minutes + 'm';
    };

    var updateShippingText = function(geoipResponse) {
        var cityName = geoipResponse.city.names.en || 'your city';
        var stateCode = geoipResponse.subdivisions[0].iso_code || 'your state'; // Get the state abbreviation

        var now = new Date();

        // If it's weekend or holiday, show "Order now" message
        if (isWeekend(now) || isHoliday(now)) {
            var htmlContent = `
              <i class="at at-clock-r"></i> 
              Order now for next available business day shipping!
            `;

            document.getElementById('shippingDestination').innerHTML = htmlContent;
            return;
        }

        // If past 1:30 PM, add a day to start from the next valid business day
        if (now.getHours() > 13 || (now.getHours() === 13 && now.getMinutes() > 30)) {
            now.setDate(now.getDate() + 1);
        }

        var startDate = getNextValidDate(new Date(now));
        startDate.setDate(startDate.getDate() + 1);  // Add an extra day for the starting range

        // Set endDate to 5 days after the startDate (adjust for holidays and weekends)
        var endDate = new Date(startDate);
        var daysToAdd = 5; 
        while (daysToAdd > 0) {
            endDate.setDate(endDate.getDate() + 1);
            if (!isWeekend(endDate) && !isHoliday(endDate)) {
                daysToAdd--;
            }
        }

        var options = { month: 'short', day: 'numeric' };
        var formattedStartDate = startDate.toLocaleDateString(undefined, options);
        var formattedEndDate = endDate.toLocaleDateString(undefined, options);

        var htmlContent = `
          <i class="at at-clock-r"></i> 
          Order in <span id="countdown-timer"></span> to arrive in ${cityName}, ${stateCode} by ${formattedStartDate} - ${formattedEndDate}
        `;

        document.getElementById('shippingDestination').innerHTML = htmlContent;

        // Start the countdown and update every second
        setInterval(displayCountdown, 1000);
    };

    var onSuccess = function(geoipResponse) {
        if (geoipResponse.country.iso_code === 'US') {
            updateShippingText(geoipResponse);
        } else {
            document.getElementById('shippingDestination').innerHTML = 'This product is only available in the US';
        }
    };

    var onError = function(error) {
        document.getElementById('shippingDestination').innerHTML = 'This product is only available in the US';
    };

    return function() {
        if (typeof geoip2 !== 'undefined') {
            geoip2.city(onSuccess, onError);
        } else {
            document.getElementById('shippingDestination').innerHTML = '';
        }
    };
})();
fillInPage();
